import React from "react"
import { graphql } from "gatsby"
import { MDXProvider } from "@mdx-js/react"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { Link } from "gatsby"
import Layout from "../components/layout"

import styles from "../styles/pages/jobs.module.scss"

const shortcodes = { Link }

export default function PageTemplate({ data: { mdx } }) {
  return (
    <Layout>
      <section className={styles.positionHeader}>
        <h1>Join Us</h1>
      </section>
      <section className={styles.position}>
        <h2>{mdx.frontmatter.title}</h2>
        <MDXProvider components={shortcodes}>
          <MDXRenderer>{mdx.body}</MDXRenderer>
        </MDXProvider>
      </section>
    </Layout>
  )
}

export const pageQuery = graphql`
  query JobPositionsQuery($id: String) {
    mdx(id: { eq: $id }) {
      id
      body
      frontmatter {
        title
      }
    }
  }
`
